module.exports = __webpack_public_path__ + "img/img_supplier_dl@2x.46805d32.png";